<style lang='less' scoped >
li {list-style-type:none;}
.had_top{display: flex; align-items:center; height:50px;padding: 10px 0;}
.headnev{display: flex; justify-content:center;width:100%;height: 120px;background-image: linear-gradient(#125196, #187BD0);}
.logo{height: 60px;width: 270px;color:#fff;margin-top:10px; margin-top: 15px;}
.logo h3{border-bottom: 1px solid white;margin: 0;}
.logo h4{margin: 0;}
.login{width:500px;height:60px;display: flex; align-items:center;justify-content:center;}
.login span{padding: 0 15px;color:#fff}
.login .span_bor{border-right: 1px solid #fff;    line-height: 15px;}
</style>

<template>
  <cx-layout class="headnev">
    <div class="had_top">
      <ul class="logo">
        <img src="static/index/biaozhi.png" alt="" />
        <h3>中国—东盟矿业信息服务平台</h3>
        <h4>中国—东盟矿业合作论坛官方网站</h4>
      </ul>
      <div class="login">
        <span>登录</span>
        <span>注册</span>
        <span class="span_bor">网站首页</span>
        <span class="span_bor" @click="onclickEng">English</span>
        <span class="span_bor">联系我们</span>
        <span>会员中心</span>
      </div>
    </div>
    <MenuPanel></MenuPanel>
  </cx-layout>
</template>

<script>
import MenuPanel from '.././layout/MenuPanel.vue'
export default {
  components: { MenuPanel },
  data()
  {
    return {}
  },
  watch: {},
  computed: {
  },
  mounted()
  {
  },
  methods: {
    onclickEng()
    {
      window.open('https://www.camining.cn/en/index.html', '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/login/Login.vue